import { render, staticRenderFns } from "./course_list.vue?vue&type=template&id=2d0e02ec&scoped=true&"
import script from "./course_list.vue?vue&type=script&lang=ts&"
export * from "./course_list.vue?vue&type=script&lang=ts&"
import style0 from "./course_list.vue?vue&type=style&index=0&id=2d0e02ec&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e02ec",
  null
  
)

export default component.exports